<template>
  <div
    class="bb-table-wrapper"
    id="board"
  >
    <vue-good-table
      :columns="headings"
      :fixed-header="false"
      :rows="spells"
      :pagination-options="{
        enabled: true,
        mode: 'records',
        perPage: 8,
        position: 'bottom',
        dropdownAllowAll: true,
        setCurrentPage: 1,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Spells per page',
        ofLabel: 'of',
        allLabel: 'All',
      }"
      :row-style-class="rowStyleClassFn"
      v-on:cell-click="onCellClick"
      styleClass="vgt-table bordered"
      theme="black-rhino"
    >
      <template v-slot:table-row="props">
        <confirm-dialog ref="confirmDialog"></confirm-dialog>

        <!-- no heading is blank label -->
        <span v-if="props.column.label == ''"> </span>

        <!-- images -->
        <span
          v-if="
            props.column.field === 'progressive_image' ||
            props.column.field === 'triggered_image' ||
            props.column.field === 'active_spell_image'
          "
        >
          <img
            :src="
              props.column.field === 'active_spell_image'
                ? getStatusImage(props)
                : tickImg
            "
            :class="isVisible(props)"
            height="50"
            width="50"
            alt="tick image"
          />
        </span>

        <!-- row number -->
        <span v-if="props.column.field === 'rowNumber'">
          {{
            props.row.originalIndex !== undefined
              ? props.row.originalIndex + 1
              : props.index + 1
          }}
        </span>
        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
      </template>

      <template #emptystate>*** Character has no spells ***</template>
    </vue-good-table>
  </div>
</template>

<script>
import 'vue-good-table-next/dist/vue-good-table-next.css'

import { VueGoodTable } from 'vue-good-table-next'
import ConfirmDialog from './ConfirmDialog.vue'
import { inject } from 'vue'

// import isEmpty from '../helpers/isEmpty'

import scrollTable from '../helpers/scrollTable'

import deleteImg from '../assets/images/bbDelete48.png'
import tickImg from '../assets/images/bbTick.png'
import crossImg from '../assets/images/bbBoxedCross.png'

export default {
  name: 'TableSpells',
  //==================================================================
  // components
  //------------
  components: {
    VueGoodTable,
    ConfirmDialog,
  },
  //==================================================================
  // setup
  //-------
  setup() {
    const global = inject('global')
    return { global }
  },
  //==================================================================
  // props
  //-------
  props: {
    headings: {
      type: Array,
      required: true,
    },
    spells: {
      type: Array,
      required: true,
    },
    // character: {
    //   type: Object,
    //   required: true
    // },
  },
  //==================================================================
  // data
  //------
  data() {
    return {
      isDeletingClearTimer: null,
      //
      spells_array: [],
      //
      deleteImg,
      tickImg,
      crossImg,
      //
      isDeleting: false,
    }
  },
  //====================================================================
  // methods
  //---------
  methods: {
    //==================================================================
    // is visible
    //------------
    isVisible(props) {
      if (props.column.field === 'active_spell_image') {
        return 'bb-img-visible'
      }

      if (
        (props.column.field == 'progressive_image' &&
          props.row['progressive'] == true) ||
        (props.column.field == 'triggered_image' &&
          props.row['triggered'] == true)
      ) {
        return 'bb-img-visible'
      }
      return 'bb-img-hidden'
    },
    getStatusImage(props) {
      if (props.column.field === 'active_spell_image') {
        return props.row?.active_spell ? this.tickImg : this.crossImg
      }

      return this.tickImg
    },
    //==================================================================
    // on cell click - open spell sheet
    //----------------------------------
    onCellClick(params) {
      // --------------------------------------------------------------
      // prevent cell click if deleting or clicking from action column
      // --------------------------------------------------------------
      if (this.isDeleting || params.column.field.substring(0, 6) == 'action') {
        return
      }
      // ---------------------------
      // show character spell panel
      // ---------------------------
      this.$emit('show-character-spell', params.row)
    },
    //==================================================================
    // colour rows
    //-------------
    rowStyleClassFn(row) {
      if (row['active_spell'] === false || row['integrated'] === false) {
        return 'rowInactiveSpell'
      }

      if (row.originalIndex % 2 === 0) {
        return 'rowNeutral'
      } else {
        return 'rowParty'
      }
    },
    //==================================================================
    // handle scroll table
    //---------------------
    handleScrollTable(dir) {
      scrollTable(document, dir)
    },
    //==================================================================
    // confirm deletion
    //------------------
    async confirmDeletion(row) {
      // -----------------------------------
      // prevent cell click whilst deleting
      // -----------------------------------
      this.isDeleting = true
      // --------------------
      // show confirm dialog
      // --------------------
      try {
        const ok = await this.$refs.confirmDialog.show({
          title: 'Delete Character Spell',
          message: 'Confirm Deletion',
          subject: row['name'],
          okButton: 'OK',
          cancelButton: 'Cancel',
        })
        // -----------------------
        // ok - emit delete event
        // -----------------------
        if (ok) this.$emit('delete-character-spell', row) // pass spell
      } finally {
        // -------------------------
        // clear any existing timer
        // -------------------------
        if (this.isDeletingClearTimer) clearTimeout(this.isDeletingClearTimer)
        // ----------------------------------
        // delay clearing isDeleting (300ms)
        // ----------------------------------
        this.isDeletingClearTimer = setTimeout(() => {
          this.isDeleting = false
          this.isDeletingClearTimer = null
        }, 300)
      }
    },
  },
  //==================================================================
  // before unmount
  //----------------
  beforeUnmount() {
    // ------------------------
    // clear any pending timer
    // ------------------------
    if (this.isDeletingClearTimer) {
      clearTimeout(this.isDeletingClearTimer)
      this.isDeletingClearTimer = null
    }
  },
}
</script>
